<template>
  <div class="w-full flex flex-col items-center gap-10 mb-10">
    <Wrapper class="max-w-xl">
      <div class="my-5 text-left">
        <h2 class="mb-2 text-2xl md:text-3xl text-blue-dark">
          <b>Datos de contacto</b>
        </h2>
        <p class="text-sm text-gray-400">
          Ingrese los datos de contacto necesarios para realizar el registro de
          la solicitud de soporte
        </p>
      </div>
      <form @submit.prevent="registerTechnicalSupport" class="w-full mb-2">
        <div class="w-full">
          <div class="w-full">
            <BaseSelect
              ref="document_type"
              id="documentType"
              label="Tipo de identificación"
              :selectOptions="customIdentificationType"
              v-model="form.identification_type"
              required="true"
            />
            <BaseInput
              ref="identification_number"
              type="text"
              :identification="form.identification_type"
              label="Número de identificación"
              placeholder="Ej:123456789"
              v-model="form.identification_number"
              required="true"
            />

            <BaseInput
              v-if="typeFromQuery === 'identification'"
              ref="new_identification_number"
              type="text"
              :identification="form.identification_type"
              label="Nuevo número de identificación"
              placeholder="Ej:123456789"
              v-model="form.new_identification_number"
              required="true"
            />

            <BaseInput
              ref="cellphone"
              name="phone"
              label="Número de teléfono"
              placeholder="Ej: 3211234567"
              v-model="form.phone"
              required="true"
              type="text"
              phoneNumber
              maxlength="15"
            />

            <BaseInput
              ref="email"
              type="text"
              label="Correo electrónico"
              v-model="form.email"
              placeholder="ejemplo@ejemplo.com"
              required="true"
              autocomplete="username"
              :maxlength="50"
            />

            <BaseInput
              v-if="typeFromQuery === 'email'"
              ref="new_email"
              type="text"
              label="Nuevo correo electrónico"
              v-model="form.newEmail"
              placeholder="ejemplo@ejemplo.com"
              required="true"
              autocomplete="username"
              :maxlength="50"
            />

            <DragDrop
              ref="annexedFile"
              label="Por favor, adjunte un soporte del documento de identidad por ambas caras (peso máximo: 30 MB):"
              buttonLabel="SELECCIONE SU ARCHIVO"
              id="technicalSupport"
              :accept="acceptExtensions"
              :extensions="extensionsSupported"
              :fileList="anexesTechnicalSupport"
              @files-handler="setAnexesTechnicalSupport"
              :multiple="false"
            />
          </div>
          <div class="w-full">
            <p class="my-3 text-xs text-left">
              Consulte la
              <span
                class="text-blue cursor-pointer hover:underline"
                @click="showModalDataPurpose"
                ><b>Finalidad del dato</b></span
              >
            </p>
            <BaseRadio
              name="personalData"
              id="personalData"
              label="¿Autorizo el tratamiento de datos personales?"
              :radioOptions="optionsYN"
              v-model="personalData"
              required="true"
            />
            <BaseRadio
              name="sensitiveData"
              id="sensitiveData"
              label="¿Autorizo el tratamiento de datos sensibles?"
              :radioOptions="optionsYN"
              v-model="sensitiveData"
              required="true"
            />
          </div>
        </div>
        <div class="form-group w-full mt-5 text-left flex flex-col">
          <p class="my-3 text-xs text-center">
            Consulte la
            <a
              class="text-blue"
              href="https://www.superfinanciera.gov.co/publicaciones/10106783/nuestra-entidadacerca-de-la-sfcpoliticas-de-la-entidadpoliticas-web-10106783/"
              target="_blank"
              rel="noopener"
              ><b
                >Política de tratamiento de datos personales y sensibles de la
                SFC</b
              ></a
            >
          </p>
          <div v-if="feedback">
            <p class="mt-2 mb-4 text-sm text-center text-red-500">
              {{ feedback }}
            </p>
          </div>
          <div class="flex flex-col gap-3">
            <a-button
              id="register-button"
              type="primary"
              shape="round"
              html-type="submit"
              :block="true"
              :loading="loading"
              :disabled="invalidForm && disableButton"
              >ENVIAR</a-button
            >
            <a-button
              type="danger"
              shape="round"
              :block="true"
              ghost
              @click.native="$router.go(-1)"
              >VOLVER</a-button
            >
          </div>
        </div>
      </form>
    </Wrapper>
    <DataPurposeModal
      :visible="showModalDataPurposeModal"
      @close="closeModalDataPurpose"
    />

    <Modal v-if="viewModal" size="md">
      <div class="text-justify">
        <h3 class="text-blue-700 text-2xl mt-2 mb-4">
          Solicitud de soporte técnico
        </h3>
        <p class="mt-4">{{ msgToModal }}</p>
      </div>
      <div class="text-center">
        <button
          @click="returnLogin"
          class="mt-4 py-2 px-4 bg-blue-500 text-white rounded-lg"
        >
          ACEPTAR
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import SignUpForm from "@/components/Login/SignUpForm";
export default {
  components: {
    SignUpForm,
  },
  data() {
    return {
      anexesTechnicalSupport: [],
      disableButton: false,
      acceptExtensions: ".pdf,.jpg,.jpeg,.png",
      extensionsSupported: [".pdf", ".jpg", ".jpeg", ".png"],
      feedback: "",
      form: {
        identification_type: "",
        identification_number: "",
        new_identification_number: "",
        email: "",
        newEmail: "",
        phone: ""
      },
      isValidFileSize: false,
      loading: false,
      msgToModal: "",
      optionsYN: [
        { id: 1, name: "Sí" },
        { id: 2, name: "No" },
      ],      
      personalData: "",
      sensitiveData: "",
      typeFromQuery: "",
      viewModal: false,
      showModalDataPurposeModal: false,
    };
  },
  async mounted() {
    const typeParam = this.$route.query.type;
    if (typeParam) {
      this.typeFromQuery = typeParam;
      if (typeParam !== "email" && typeParam !== "identification") {
        this.returnLogin();
      }
    } else {
      this.returnLogin();
    }
  },
  methods: {
    showModalDataPurpose() {
      this.showModalDataPurposeModal = true;
    },
    closeModalDataPurpose() {
      this.showModalDataPurposeModal = false;
    },
    checkFileSize(files) {
      let size = 0;
      files.forEach((item) => {
        size += item.size;
      });
      size = size / (1024 * 1024);
      return size;
    },
    checkForm() {
      let valid = false;

      if (
        this.form.identification_number &&
        this.form.identification_type == 1 &&
        !this.$validator.isNumeric(this.form.identification_number + "")
      ) {
        this.feedback = "Ingrese un número válido para el campo documento";
        return valid;
      }

      if (
        this.form.new_identification_number &&
        this.form.identification_type == 1 &&
        !this.$validator.isNumeric(this.form.new_identification_number + "")
      ) {
        this.feedback =
          "Ingrese un número válido para el campo de nuevo documento";
        return valid;
      }

      if (this.form.email && !this.$validator.isEmail(this.form.email)) {
        this.feedback =
          "En el campo Correo electrónico debe ingresar un correo válido";
        return valid;
      }

      if (this.form.newEmail && !this.$validator.isEmail(this.form.newEmail)) {
        this.feedback =
          "En el campo Nuevo correo electrónico debe ingresar un correo válido";
        return valid;
      }

      if (this.anexesTechnicalSupport.length == 0) {
        this.feedback =
          "Debe adjuntar el soporte del documento de identidad por ambos lados";
        return valid;
      }

      if (this.personalData != 1) {
        this.feedback = "Debe autorizar el tratamiento de datos personales";
        return valid;
      }

      this.feedback = "";
      valid = true;
      return valid;
    },
    returnLogin() {
      this.$router.push("/login").catch(() => {});
    },
    async registerTechnicalSupport() {
      this.loading = true;
      this.disableButton = true;

      if (this.validateRequiredField() && this.checkForm() && this.isValidFileSize) {
        let files = {
          anexesTechnicalSupport: this.anexesTechnicalSupport,
        };

        let form = {
          identification_type: this.form.identification_type,
          identification_number: this.form.identification_number,
          phone: this.form.phone,
          email: this.form.email,

          check_personal_data: this.personalData == 1 ? "true" : "false",
          check_sensitive_data: this.sensitiveData == 1 ? "true" : "false",
          type_problem: this.typeFromQuery,
          accepted: null,
        };

        if (this.typeFromQuery === "email") {
          form.new_email = this.form.newEmail;
        } else {
          form.new_identification_number = this.form.new_identification_number;
        }

        let { data, error } = await this.$api.createTechnicalSupport(
          form,
          files
        );
        if (error) {
          this.loading = false;
          this.disableButton = false;
          if (error.status_code === 404) {
            this.msgToModal =
              "No es posible registrar la solicitud de soporte técnico porque los datos ingresados no coinciden con los de un usuario registrado o son incorrectos";
            this.viewModal = true;
            return;
          }

          this.msgToModal =
            this.typeFromQuery === "email"
              ? "No es posible registrar la solicitud de soporte técnico porque ya existe un usuario registrado con ese correo electrónico"
              : "No es posible registrar la solicitud de soporte técnico porque ya existe un usuario registrado con ese número de documento";
          this.viewModal = true;
          return;
        }

        if (data) {
          this.loading = false;
          this.disableButton = false;
          this.msgToModal =
            "Solicitud de soporte técnico registrada correctamente";
          this.viewModal = true;
          return;
        }
      } else {
        this.loading = false;
        this.disableButton = false;
        return;
      }
    },
    setAnexesTechnicalSupport(files) {
      let size = this.checkFileSize([...files]);
      if (size <= 30) {
        this.anexesTechnicalSupport = files;
        this.feedback = "";
        this.isValidFileSize = true;
      } else {
        this.feedback =
          "El archivo que intenta cargar, supera el peso máximo (30 MB) permitido para el soporte del documento de identidad.";
          this.isValidFileSize = false;
      }
    },

    validateRequiredField() {
      let refs = this.$refs;
      let valid = false;
      this.feedback = "";
      if (Object.keys(this.form).length === 0) {
        this.feedback = "Todos los campos son obligatorios";
        return valid;
      }
      for (let ref in refs) {
        if (
          (refs[ref] && refs[ref].required && refs[ref].value === "") ||
          refs[ref]?.invalid
        ) {
          let y =
            refs[ref].$el.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo(0, y);
          refs[ref].setInvalid(true);
          return valid;
        }
      }
      return true;
    },
  },
  computed: {
    invalidForm: function () {
      let invalid = true;
      if (this.personalData == 2) {
        this.feedback =
          "Para registrar la solicitud de soporte, debe aprobar los términos y condiciones";
      } else if (this.personalData == 1) {
        invalid = false;
        this.feedback = "";
      }
      return invalid;
    },
    customIdentificationType: function () {
      return this.$store.state.form?.optionsIdentificationType?.filter(
        (identification) => identification.id != 3
      );
    },
    formOptions: function () {
      return this.$store.state.form;
    },
  },
};
</script>
